import {
  appendMobileReturnStateToUrl,
  createMobileReturnUrl,
  parseMobileReturnState,
} from "../util/mobilePageContext.ts";

export type GameLogDetailCloseContext = {
  href: string;
  label: string;
  source: "fallback" | "return";
};

export const resolveGameLogDetailCloseContext = ({
  fallbackHref,
  fallbackLabel,
  search,
}: {
  fallbackHref: string;
  fallbackLabel: string;
  search: string;
}): GameLogDetailCloseContext => {
  const returnState = parseMobileReturnState(search);

  if (returnState.returnHref) {
    return {
      href: returnState.returnHref,
      label: returnState.returnLabel ?? fallbackLabel,
      source: "return",
    };
  }

  return {
    href: fallbackHref,
    label: fallbackLabel,
    source: "fallback",
  };
};

export const createGameLogRowMobileHref = ({
  detailHref,
  returnHref,
  returnLabel,
  scrollY,
}: {
  detailHref: string;
  returnHref: string;
  returnLabel: string;
  scrollY?: number;
}) =>
  createMobileReturnUrl(detailHref, {
    captureCurrentReturnUrl: false,
    pageID: "gameLog",
    returnHref,
    returnLabel,
    scrollY,
    sourcePage: "gameLog",
  });

export const carryGameLogDetailReturnState = ({
  detailHref,
  search,
}: {
  detailHref: string;
  search: string;
}) =>
  appendMobileReturnStateToUrl(
    detailHref,
    parseMobileReturnState(search),
  );
